// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");

function getPdg(particle) {
  return particle.pdg;
}

function getName(particle) {
  return particle.name;
}

function getMass(particle) {
  return particle.mass;
}

function getWidth(particle) {
  return particle.width;
}

function getCharge(particle) {
  return particle.charge;
}

function getI(particle) {
  return particle.iValue;
}

function getG(particle) {
  return particle.gValue;
}

function getC(particle) {
  return particle.cValue;
}

function getP(particle) {
  return particle.pValue;
}

function isAnti(particle) {
  return particle.anti;
}

function getLatex(particle) {
  return "\\(" + (particle.latex + "\\)");
}

function getRawLatex(particle) {
  return particle.latex;
}

function invert(particle, particles) {
  return Belt_MapInt.get(particles, Math.imul(-1, particle.pdg));
}

function getPdgName(particle) {
  return "PDG " + (String(particle.pdg) + (": " + particle.name));
}

function getUnknownQuantity(quantity) {
  if (quantity !== undefined) {
    return String(quantity);
  } else {
    return " ?";
  }
}

function makeProperty(param) {
  return {
          property: param[0],
          value: param[1],
          units: param[2]
        };
}

function getProperties(p) {
  return Belt_Array.map([
              [
                "PDG",
                String(p.pdg),
                undefined
              ],
              [
                "Mass",
                getUnknownQuantity(p.mass),
                "MeV"
              ],
              [
                "Charge",
                getUnknownQuantity(p.charge),
                undefined
              ],
              [
                "Width",
                getUnknownQuantity(p.width),
                undefined
              ],
              [
                "I",
                getUnknownQuantity(p.iValue),
                undefined
              ],
              [
                "G",
                String(p.gValue),
                undefined
              ],
              [
                "C",
                String(p.cValue),
                undefined
              ],
              [
                "P",
                String(p.pValue),
                undefined
              ]
            ], (function (x) {
                return makeProperty(x);
              }));
}

exports.getPdg = getPdg;
exports.getName = getName;
exports.getMass = getMass;
exports.getWidth = getWidth;
exports.getCharge = getCharge;
exports.getI = getI;
exports.getG = getG;
exports.getC = getC;
exports.getP = getP;
exports.isAnti = isAnti;
exports.getLatex = getLatex;
exports.getRawLatex = getRawLatex;
exports.invert = invert;
exports.getPdgName = getPdgName;
exports.getUnknownQuantity = getUnknownQuantity;
exports.makeProperty = makeProperty;
exports.getProperties = getProperties;
/* No side effect */
